<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top" v-show="showPageContent">
        <div class="left">
          <h1 class="title">Ваш заказ №{{order_id}}</h1>
          <span class="status" :class="order.status_color">{{order.status_text}}</span>
        </div>
        <div class="right">
          <standart-button @click="repeat()" text="Повторить заказ"></standart-button>
          <standart-button @click="cancel()" style_type="danger" text="Отменить заказ"></standart-button>
        </div>
      </div>

      <div class="page_content order-detail" v-show="showPageContent">

        <div class="main">
          <div class="left">
            <div class="panel buyer" v-if="order.person_type_id == 1">
              <span class="panel-title">Данные покупателя</span>
              <div class="rows">
                <div class="item">
                  <span class="desc">Имя:</span>
                  <span class="val">{{order.buyer?.name}}</span>
                </div>
                <div class="item">
                  <span class="desc">Телефон:</span>
                  <span class="val">{{order.buyer?.phone}}</span>
                </div>
                <div class="item">
                  <span class="desc">E-mail:</span>
                  <span class="val">{{order.buyer?.email}}</span>
                </div>
              </div>
            </div>
            <div class="panel buyer" v-if="order.person_type_id == 2">
              <span class="panel-title">Данные покупателя</span>
              <div class="rows">
                <div class="item">
                  <span class="desc">Название компании:</span>
                  <span class="val">{{order.buyer?.title}}</span>
                </div>
                <div class="item">
                  <span class="desc">ИНН:</span>
                  <span class="val">{{order.buyer?.inn}}</span>
                </div>
                <div class="item">
                  <span class="desc">КПП:</span>
                  <span class="val">{{order.buyer?.kpp}}</span>
                </div>
                <div class="item">
                  <span class="desc">ОГРН/ОГРНИП:</span>
                  <span class="val">{{order.buyer?.ogrn}}</span>
                </div>
                <div class="item">
                  <span class="desc">Телефон компании:</span>
                  <span class="val">{{order.buyer?.phone}}</span>
                </div>
                <div class="item">
                  <span class="desc">Почта компании:</span>
                  <span class="val">{{order.buyer?.email}}</span>
                </div>
                <div class="item">
                  <span class="desc">Юридический адрес:</span>
                  <span class="val">{{order.buyer?.l_address}}</span>
                </div>
                <div class="comment_sep"></div>
                <div class="item comment">
                  <span class="desc">Комментарий:</span>
                  <span class="val">{{order.props?.USER_DESCRIPTION}}</span>
                </div>
              </div>
            </div>
            <div class="panel recipient">
              <span class="panel-title">Данные получателя</span>
              <div class="rows">
                <div class="item">
                  <span class="desc">Имя:</span>
                  <span class="val">{{order.recipient?.name}}</span>
                </div>
                <div class="item">
                  <span class="desc">Телефон:</span>
                  <span class="val">{{order.recipient?.phone}}</span>
                </div>
              </div>
            </div>
            <div class="panel delivery">
              <span class="panel-title">Способ доставки</span>
              <div class="rows">
                <div class="item">
                  <span class="desc">Доставка:</span>
                  <span class="val">{{order.delivery?.name}}</span>
                </div>
                <div class="item" v-if="order.delivery?.id == '20'">
                  <span class="desc">Дата доставки:</span>
                  <span class="val">{{order.props?.DELIVERY_DATE}}</span>
                </div>
                <div class="item">
                  <span class="desc">Стоимость:</span>
                  <span class="val">{{order.delivery?.price}}</span>
                </div>
                <div class="item" v-if="order.delivery?.id == '20'">
                  <span class="desc">Адрес доставки:</span>
                  <span class="val">{{order.props?.DELIVERY_ADDRESS}}</span>
                </div>
              </div>
            </div>
            <div class="panel payment">
              <span class="panel-title">Способ оплаты</span>
              <div class="content">
                <div class="rows">
                  <div class="item">
                    <span class="desc">Способ оплаты:</span>
                    <span class="val">{{order.payment?.name}}</span>
                  </div>
                  <div class="item">
                    <span class="desc">Итого к оплате:</span>
                    <span class="val">{{order.price}}</span>
                  </div>
                  <div class="item">
                    <span class="desc">Статус:</span>
                    <span class="val" :class="order.payed_color">{{order.payed_text}}</span>
                  </div>
                </div>
                <a
                    v-if="order.payment.show_payment_link"
                    :href="order.payment_link"
                    target="_blank" class="payment_button">Оплатить</a>
              </div>
            </div>
          </div>
          <div class="right">
            <products-block :basket-data="order?.basket?.list"></products-block>
          </div>
        </div>

      </div>

    </template>
  </main-template>
</template>

<script>
import MainTemplate from '@/components/MainTemplate.vue';
import ProductsBlock from "@/components/order/ProductsBlock";
import StandartButton from "@/components/share/StandartButton";
import axios from "axios";





export default {
  name: 'OrderDetailView',
  components: {
    StandartButton,
    ProductsBlock,
    MainTemplate,
  },
  data() {
    return{
      order_id : this.$route.params.order_id,
      order: {
        payment : {
          show_payment_link : false
        }
      },
      showPageContent: false
    }
  },
  mounted() {
    this.loadData();
  },
  methods : {
    loadData : async function() {
      let order_id = this.$route.params.order_id;
      let res = await axios.get(
          window.api_url + "order/detail?order_id="+order_id
      );

      this.order = res.data.data;

      this.order.payment_link = window.server_url + "lk/?payment=y&ORDER_ID="+order_id;

      this.showPageContent = true;
    },
    repeat : async function() {
      console.log("Повтор заказа: " + this.order_id);
      await axios.get(window.api_url + "order/repeat?id="+this.order_id);
      this.$router.push({name:'basket'});
    },
    cancel : async function() {
      let conf = confirm("Вы уверены что хотите отменить заказ №" + this.order_id + "?");

      if(conf) {
        console.log("Отмена заказа: " + this.order_id);
        await axios.get(window.api_url + "order/cancel?id="+this.order_id);
        window.location.reload();
      }
    },
    initPayment : async function() {
      console.log("initPayment");
    }
  }
}
</script>

<style scoped>

.page_top {
  margin-bottom: 20px;
  align-items: center;
  background: var(--White);
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 17px 20px;
}

.page_top .left {
  display: flex;
  gap: 6px;
  flex-direction: column;
}

.page_top .left .status {
  color: #333;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.page_top .left .status.wait_payment {
  color: var(--Blue, #1B78BC);
}

.page_top .left .status.new {
  color: var(--Green, #69BE15);
}

.page_top .left .status.cancelled {
  color: var(--Red, #FA4B61);
}

.page_top .left .status.in_processing {
  color: #F58646;
}

.page_top .left .status.sent {
  color: var(--Black, #222);
}

.page_top .left .status.completed {
  color: var(--Green, #69BE15);
}

.page_top .left .status.paid {
  color: var(--Gray, #656565);
}

.page_top .left .status.return {
  color: var(--Red, #FA4B61);
}

.page_top .right {
  display: flex;
  gap: 12px;
}

.order-detail {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.order-detail .top {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 17px 20px;
}

.order-detail .main {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.order-detail .main .left {
  flex: 1;
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.order-detail .main .right {
  flex: 2;
}

.order-detail .main .left .panel {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.order-detail .main .left .panel .panel-title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}

.order-detail .main .left .panel .content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.order-detail .main .left .panel .rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.order-detail .main .left .panel .rows .item {
  display: flex;
  justify-content: space-between;
}

.order-detail .main .left .panel .comment_sep {
  background: #EDEDED;
  height: 1px;
  width: 100%;
  margin: 6px 0px;
}

.order-detail .main .left .panel .rows .item.comment {
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 8px;
  text-align: start;
}

.order-detail .main .left .panel .rows .item .desc {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.order-detail .main .left .panel .rows .item .val {
  color: var(--Black, #222);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  flex: 1;
}

.order-detail .main .left .panel .rows .item.comment .val{
  text-align: left;
}

.order-detail .main .left .panel .rows .item .val.red {
  color: var(--Red, #FA4B61);
}

.order-detail .main .left .panel .rows .item .val.green {
  color: var(--Green, #69BE15);
}

.payment_button {
  outline: none;
  border: none;
  border-radius: 8px;
  background: rgba(27, 120, 188, 0.10);
  height: 49px;
  padding: 12px 12px;
  width: 100%;

  color: var(--Blue, #1B78BC);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 123%;

  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9px;

  flex: 1;
  text-decoration: none;
  box-sizing: border-box;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .page_top {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 24px;
  }

  .page_top .left {
    width: 100%;
  }

  .page_top .right {
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
    gap: 10px;
  }

  .page_top .right .standart_button {
    width: 100%;
  }

  .order-detail .main {
    flex-direction: column;
  }

  .order-detail .main .left{
    gap: 10px;
  }

  .order-detail .main .left .panel {
    gap: 18px;
  }
}
</style>



<style>

.page_top .standart_button {
  width: 180px;
  height: 44px;
}

.order_block.products-block {
  padding: 14px 20px 14px 20px;
}

.order_block.products-block h3.title {
  display: none;
}

.order_block.products-block .products_list .item:first-child {
  padding-top: unset;
  border-top: unset;
}

.order_block.products-block .products_list .item:last-child {
  padding-bottom: unset;
}


/*MOBILE*/
@media (max-width: 1250px)
{

}

</style>
